module.exports = __webpack_public_path__ + "img/button1.4d44bfd1.png";